import { render, staticRenderFns } from "./OtherSource.vue?vue&type=template&id=461fb3e2"
import script from "./OtherSource.vue?vue&type=script&lang=js"
export * from "./OtherSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports